// extracted by mini-css-extract-plugin
module.exports = {"modal":"PrivacyModal_modal__2AVhK","top":"PrivacyModal_top__fUerI","bottom":"PrivacyModal_bottom__38ka1","first":"PrivacyModal_first__cFiZv","second":"PrivacyModal_second__21kS4"};